// extracted by mini-css-extract-plugin
export default {"inner":"Page_inner__PByNa","txttick11":"Page_txttick11__m5FlG"};